

import React, { useState } from "react";
import { ErrorMessage } from "formik";
import { ErrorToast } from "../../Utils/SweetAlert";
import "./style.css";

const IconUpload = ({ values, setFieldValue, addImageApi, selectIcon, type = "icon" }) => {
  const [isUploading, setIsUploading] = useState(false);

  const handleImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      event.preventDefault();
      setIsUploading(true);

      const formData = new FormData();
      formData.append("images", event.target.files[0]);

      addImageApi.mutate(formData, {
        onSuccess: (response) => {
          setFieldValue(type === "icon" ? "icon" : "image", response?.data[0]);
          setIsUploading(false);
        },
        onError: (error) => {
          ErrorToast(error?.response?.data?.message || "Server Error.");
          setIsUploading(false);
        },
      });
    }
  };

  return (
    <div className="icon-upload-container">
      <div className="user-information-profile-section">

        <label htmlFor="imageInput" className="image-upload-label position-relative d-inline-block">
          <img
            src={type === "icon" ? (values?.icon ? values?.icon : selectIcon) : (values?.image ? values?.image : selectIcon)}
            alt={type === "icon" ? "icon" : "image"}
            className={`upload-image w-sm-70 h-sm-70 rounded ${isUploading ? 'opacity-50' : ''}`}
            width={100}
            height={100}
            name={type === "icon" ? "icon" : "image"}
          />
          {isUploading && (
            <div className="position-absolute top-50 start-50 translate-middle">
              <div className="spinner-border loader-theme" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}
          <div className="user-icon-change-profile-button">
            {isUploading ? "Uploading..." : (type === "icon" ? (values?.icon === "" ? "Select" : "Change") : (values?.image === "" ? "Select" : "Change")) + " Icon"}
          </div>

          <input
            id="imageInput"
            type="file"
            multiple={false}
            name={type === "icon" ? "icon" : "image"}
            accept="image/png, image/jpeg, image/jpg"
            className="filetype d-none"
            onChange={handleImageChange}
          />
        </label>
      </div>
      <ErrorMessage name={type === "icon" ? "icon" : "image"} component="div" className="text-danger" />
    </div>
  );
};

export default IconUpload;






